<template>
	<div>
		<!-- 关键字部分 -->
		<!-- <div class="pre_btn" v-show="show_key">
      <slot name="key_btn"></slot>
    </div> -->
		<!-- table部分 -->
		<div id="pre_tab" class="pre_tab" v-loading="fullloading" element-loading-text="拼命加载中......"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
				<slot name="tab_title"></slot>
				<slot name="tab_tr" v-for="data_tr in data_tab" :item="data_tr"></slot>
				<slot name="tab_tr_all" :item="all_ammount"></slot>
			</table>
		</div>
		<!-- 分页部分 -->
		<div class="pre_page">
			<ul style="text-align: right; margin-right: 20px;">

				<li style="line-height: 24px;height: 24px;padding: 2px 6px;">
					<span>分页:
						<input class="short-word-1" style="line-height: 24px;height: 24px;width: 48px;" type="text"
							v-model="page_length" @change="refresh_data('PAGE_LENGTH_CHANGE')" /></span>

					当前页：<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp; <a href="#"
						@click="firstpage">首页</a>|
					<a href="#" @click="beforepage">上一页</a>|
					<a href="#" @click="nextpage">下一页</a>|
					<a href="#" @click="lastpage">尾页</a>

					<input class="short-word-1" style="line-height: 24px;height: 24px;width: 48px;" type="text"
						v-model="jumppage" value="" /><a href="#" @click="gopage" class="go">Go</a>
				</li>
			</ul>
		</div>
		<!-- 弹出向导层 start-->
		<div id="pop" class="pop" v-bind:style="{ width: screenWidth+'px', height: screenHeight + 'px' }"
			v-show="pop_show">
			<span class="pop_bg" @click="hide()"></span>
			<div id="pop_bodyup" class="pop_content">
				<slot name="tab_addorupdate"></slot>
			</div>
		</div>
		<!-- 弹出向导层 end-->
	</div>
</template>
<script>
	/*
	名称：Table组件 纯table+key
	日期：2019-03-21
	作者：hj

	add 2020-11-08 替换等待提示和反馈提示为elementUI对应组件

	确定为  自适应宽度

	add 2022-01-25 增加分页选择设置
	*/

	// import '@/assets/css/pop.css';

	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	import {
		ReplaceAll,JsonCheck,JsonStr,ChangeSpecial,BackSpecial
	} from '@/utils/method.js';
	// import '@/assets/css/pre_table2.css';
	export default {
		name: "pre_table_nokey",
		data() {
			return {
				data_tab: [],
				data_img: [],
				show_key: true,
				maxpage: '',
				nowpage: '',
				page_length: 20, //add 2022-01-25 默认分页长度
				all_count: 0,
				jumppage: '',
				fullloading: false,
				pop_show: false,
				show_btn_add: true,
				/*备份 上一次的查询方式，如果方式改变,则应该重新初始化page*/
				back_sel_type: '',
				sel_key: '',
				temp_scroll: 0,
				all_ammount: {},

				screenWidth: '',
				screenHeight: ''
			};
		},
		props: {
			api_url: String,
			pre_post: String,
			/* 需要 增 删 改 就绑定这个 */
			pre_post_upd: {
				type: String,
				default: ''
			},
			/* 操作标记 当保存操作是不关闭窗口,提交则关闭窗口 就绑定这个 */
			pre_action: {
				type: String,
				default: ''
			}
		},
		created: function() {
			this.nowpage = 1;

			this.$nextTick(function() {
				$('html,body').animate({
					scrollTop: '0px'
				}, 500);
			})

			if (BrowserGet() == 'firefox') {
				this.temp_scroll = 24;
			}

		},
		watch: {
			pre_post(val) {
				this.loaddata();
			},
			pre_post_upd(val) {
				if (String(val) != '')
					// console.log(val);
					this.neworupdate();
			}
		},
		mounted: function() {
			this.loaddata();

			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			window.addEventListener('scroll', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);
			// 这里只是操作dom
			window.addEventListener('resize', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);

			// this.$set(this.ischeck, 'isok', '1')
		},
		methods: {
			chang_style: function() {
				this.$nextTick(function() {
					this.screenWidth = $(window).width();
					this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
					var scrolltop = $(document).scrollTop(); //获取当前窗口距离页面顶部高度
					// console.log('屏宽='+this.screenWidth+' 屏高='+this.screenHeight);
					let tw = 0,
						tleft = 0,
						tright = 0;
					tleft = $('#mleft').width();
					tright = $('#mright').width();
					tw = tright - 8;
					let css = '';
					css = 'width: ' + tw + 'px;max-width: ' + tw + 'px;';

					var t = document.getElementById('pre_tab');
					// console.log(t);
					try {
						if (t == null) {
							// alert('11');
						} else {
							document.getElementById('pre_tab').style.cssText = css;
						}
					} catch (e) {}

				});
			},
			firstpage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage = 1;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			lastpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage = this.maxpage;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			gopage: function() {
				if (Number(this.jumppage) > 0 && Number(this.jumppage) <= Number(this.maxpage)) {
					this.nowpage = this.jumppage;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '跳转页数不在规定范围内,请检查' + this.jumppage,
						type: 'warning'
					});
				}
			},
			loaddata: function() {

				this.data_tab = [];
				this.data_img = [];

				if (typeof(this.api_url) === 'undefined' || String(this.api_url) == '') {
					return;
				}

				if (typeof(this.pre_post) === 'undefined' || String(this.pre_post) == '') {
					return;
				}

				this.fullloading = true;
				this.$post(
					this.api_url,
					this.pre_post
				).then(res => {
					this.fullloading = false;
					this.data_tab = [];
					try {
						// console.log(JsonCheck(res));
						res = JSON.parse(JsonCheck(res));
						// res = JSON.parse(res);
						// console.log(res);
						if (Number.parseInt(res.data.status) == 1) {
							this.maxpage = res.data.allpage;
							if (Number(res.data.allpage) == 0) {
								this.$message({
									message: '没有查询到数据',
									type: 'success'
								});
							} else {
								// this.data_tab = res.data.data;
								let t = res.data.data;
								for (let i = 0; i < t.length; i++) {
									let arr = [];
									for (let j in t[i]) {

										let o = {};
										o.key = j;
										// o.val = (t[i][j]); //恢复特殊符号
										o.val = JsonStr(t[i][j]); //恢复特殊符号
										arr.push(o);
									}
									this.data_tab.push(arr);
								}

							}
						} else {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});
						}



					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});
			},
			refresh_data: function(action, tempdata) {
				// action   操作指示
				// tempdata 传输数据
				this.$emit("tab-event", action, this.nowpage, this.page_length, tempdata);
			},
			new_one_data: function() {
				this.data_tab.push({});
			},
			showpop: function() {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.chang_style();
			},
			hide: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			neworupdate: function() {

				this.fullloading = true;
				this.$post(
					this.api_url,
					this.pre_post_upd,
				).then(res => {

					try {
						res = JSON.parse(res);
						// console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							// console.log(res.data);
							let parm = '';
							parm = JSON.stringify({
								"msg": res.data.msg,
								"sheet_no": res.data.parm.sheet_no,
								"sys_date": res.data.parm.sys_date,
								"new_id": res.data.new_id
							});

							this.refresh_data('UPDATE_OK', parm);

						} else {
							this.$message.error(res.data.msg);
						}

						this.fullloading = false;
					} catch (ex) {
						this.fullloading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});
			},
			setCurrentRowJson: function(key, id) {
				// console.log('key=' + key + ' id=' + id );
				for (var i = 0; i < this.data_tab.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.data_tab[i][1].val == id) {
						document.getElementById(key + id).style.background = '#92a4f3';
					} else {
						if (this.data_tab[i][1].val % 2 == 0) {
							document.getElementById(key + this.data_tab[i][1].val).style.background = '#fff';
						} else {
							document.getElementById(key + this.data_tab[i][1].val).style.background = '#f5f5f5';
						}
					}
				}
			},
			setCurrentRowJsonOld: function(key, id) {
				// console.log('key=' + key + ' id=' + id );
				for (var i = 0; i < this.data_tab.length; i++) {
					// console.log(this.data_tab[i][1]);
					if (this.data_tab[i][1].val == id) {
						document.getElementById(key + id).style.background = '#92a4f3';
					} else {
						if (this.data_tab[i][1].val % 2 == 0) {
							document.getElementById(key + this.data_tab[i][1].val).style.background = '#fff';
						} else {
							document.getElementById(key + this.data_tab[i][1].val).style.background = '#f5f5f5';
						}
					}
				}
			},
			selectAllRow: function(sel) {
				let flag = false;
				if (sel == '1') {
					flag = true;
				}
				for (var i = 0; i < this.data_tab.length; i++) {
					for (let j = 0; j < this.data_tab[i].length; j++) {
						if (this.data_tab[i][j].key == 'sel') {
							// console.log(this.data_tab[i][j].key + '=' + this.data_tab[i][j].key);
							this.data_tab[i][j].val = flag;
							break;
						}
					}
				}
			},
			selectAllPass: function() {
				console.log('审核所有人');
				for (var i = 0; i < this.data_tab.length; i++) {
					for (let j = 0; j < this.data_tab[i].length; j++) {
						if (this.data_tab[i][j].key == 'sel' && this.data_tab[i][j].val == true) {
							console.log('审核目标:' + this.data_tab[i][j].key + '=' + this.data_tab[i][j].key);
							this.$emit("tab-event", 'PASS', this.nowpage, this.page_length, this.data_tab[i]);
							break;
						}
					}
				}
			}
		}
	};
</script>

<style scoped>
	/* pre_search */
	.pre_btn {
		text-align: left;
	}

	.pre_btn>label {
		position: relative;
		/* left: 2%; */
	}

	.pre_btn>input {
		position: relative;
		/* left: 2%; */
	}

	.pre_btn>input :focus {
		border: 1px solid #024aee;
		background-color: #aaa;
	}



	.pre_tab {
		padding-left: 12px;
		width: calc(100% -12px);
		overflow-x: auto;
		white-space: nowrap;
	}

	.pre_view_tab {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;

		margin: 0;
		padding: 0;


		flex: 1;



	}

	/*
   style="table-layout: fixed;"：设置表格大小固定 （列宽由表格宽度和列宽度设定）。

   style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"

   　　　overflow：溢出内容会被修剪，并且其余内容是不可见的。

   　　　white-space：规定段落中的文本不进行换行

   　　　text-overflow：显示省略符号来代表被修剪的文本。
   */

	.pre_view_tab th,
	.pre_view_tab td {
		padding: 2px 6px 2px 6px;
		vertical-align: middle;
		box-sizing: border-box;

		font-size: 16px;

		max-width: 256px;
		/* min-width: 128px; */
		/* width: 128px;
    max-width: 128px; */
		/* height: 24px;
    line-height: 22px;

    max-height: 72px !important; */

		/* overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all; */
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */

		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);

		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
		/* border: 1px solid #808080; */

	}

	/* 首列是ID,不排序,隐藏 */
	.pre_view_tab tr td:nth-child(1) {
		display: none;
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	.pre_view_tab tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
		text-align: center;
	}

	.pre_view_tab tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.pre_view_tab td input {
		width: 100%;
		display: inline-block;
		word-break: break-all;
		white-space: pre;
		/* 然后页面就能成功识别 ‘\r\n’ 或 ‘\n’ ，并换行显示. */
	}

	.pre_view_tab td input:hover {
		cursor: pointer;
	}

	/*  .pre_view_tab .tab_header td:nth-last-child(2),
  .pre_view_tab .tab_body td:nth-last-child(2),
  .pre_view_tab .tab_header td:nth-last-child(1),
  .pre_view_tab .tab_body td:nth-last-child(1) {
    display: none;
  } */

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_view_tab td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* 表格内输入框 */
	.pre_view_tab td input {
		width: 100%;
		display: inline-block;
		word-break: break-all;
		white-space: pre;
		/* 然后页面就能成功识别 ‘\r\n’ 或 ‘\n’ ，并换行显示. */
	}

	.pre_view_tab td img {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 5px;
		margin-right: 5px;
	}

	.pre_view_tab td img:hover {
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_view_tab td span {
		display: inline-block;
		border: 1px solid black;
		background: #aaa;
		text-align: center;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 2px;
		margin-right: 2px;
	}

	.pre_view_tab tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_view_tab tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_view_tab tr:hover {
		background-color: #B7D3F4 !important;
	}

	/*  .pre_view_tab tr:focus {
    background: #92a4f3 !important;
  } */
	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		/* height: 100%; */
		text-decoration: none;
		color: #333;
	}

	.pre_view_tab tr>td>a:focus {
		background: #92a4f3 !important;
	}


	.tab_add {
		width: 95%;
		display: flex;
		margin-top: 5px;
		margin-left: 2%;
		background-color: rgba(103, 233, 77, 0.644);
	}

	.tab_upd {
		width: 95%;
		display: flex;
		margin-left: 2%;
		background-color: rgba(209, 212, 36, 0.644);
	}

	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: 5px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}

	.tab-row {
		margin-top: 10px;
		display: inline-flex;
		flex-direction: row;
		flex-wrap: wrap;

	}
</style>